export default "__VITE_ASSET__B4NwMyCr__"